import { useState, useEffect, useMemo } from 'react';
import { useGetRoleplayView } from 'features/roleplay/Roleplay.queries';
import Organization from 'infrastructure/Organization';
import { useLocation, useHistory } from 'react-router-dom';
import { CircularProgress, Grid } from '@material-ui/core';
const RedirectRoleplay = () => {
  const location = useLocation();
  let history = useHistory();
  const [id, setID] = useState('');
  const [toReview, setToReview] = useState(false);

  useEffect(() => {
    if (!location?.state) return;

    const uuid = location?.state?.uuid;
    const reviewFlag = location?.state?.to_review;

    if (uuid) setID(uuid);
    if (typeof reviewFlag === 'boolean') setToReview(reviewFlag);
  }, [location.state]);

  const { data, isLoading } = useGetRoleplayView({ roleplay_id: id, enabled: !!id });

  const isInteractive = useMemo(() => {
    if (!data) return null;
    return data.interactive ?? null;
  }, [data]);

  useEffect(() => {
    if (isInteractive === null || !id) return;

    let targetPath = '';

    if (toReview) {
      targetPath = isInteractive ? `/realplay-review-qualified/${id}` : `/roleplay-review/${id}`;
    } else if (Organization.isRep()) {
      targetPath = isInteractive ? `/realplay/${id}` : `/roleplay/${id}`;
    }

    if (targetPath) history.push(targetPath);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInteractive, id, toReview]);

  return (
    <Grid container direction="row" spacing={2} style={{ padding: '1rem 0 0 1rem', width: '100%' }}>
      {isLoading && <CircularProgress size={18} color="inherit" />}
    </Grid>
  );
};

export default RedirectRoleplay;
